export type ToastData = {
  type?: "success" | "error" | "info" | "warning";
  message?: string;
  ref?: any;
  show: boolean;
  onClick?: () => void;
};

export type User = {
  /** Permissions à la racine (réponse API Tracking) ou dans user (Admin) */
  app_permissions?: Array<{ id?: number; permission?: string; model?: string; app?: string }>;
  user: {
    due_date: any;
    assessment_reference: any;
    tax_identification_number: string;
    tax_amount_due: any;
    tax_is_due: boolean;
    groups: any[];
    id: number;
    area_id?: number;
    area_name?: string;
    sub_area_name?: string;
    city_name?: string;
    company_id?: number;
    dealer_id?: number;
    customer_id?: number;
    institution_id?: number;
    institution_name?: string;
    title?: string;
    name: string;
    username: string;
    email: string;
    city: string;
    country: string;
    phone_number: string;
    roles: string;
    profile_picture?: string;
    payment_api_pk?: string;
    app_permissions?:any[]
  };
  auth: {
    access_token?: string;
    tokenExpirationDate?: string | Date;
  };
};

export type Credentials = {
  username: string;
  password: string;
};

export type SignUpFormData = {
  yourName: string;
  username: string;
  email: string;
  password: string;
  phoneNumber: string;
};

export type VerifyAccountData = {
  username: string;
  otpCode: string;
};
export type AuthUser = any;

export interface IRequireStore {
  storeProvider: () => any;
}

export enum ReceiveMethod {
  mobileMoney = "Mobile Money",
  bankTransfer = "Bank Transfer",
  airtime = "Airtime",
}

export const momoChannels = ["mtn", "vodafone", "airteltigo"];

export interface Payment {
  id: string;
  amount: number;
  date: string;
  status: 'pas à jour' | 'échoué' | 'payé' | 'à jour';
  method: 'Wave' | 'Orange Money' | 'MTN Money' | 'Moov Money';
}

export interface Taxpayer {
  id: string;
  name: string;
  type: 'Bar' | 'Hotel' | 'Commerce';
  phone: string;
  zone: string;
  qrCode: string;
  dueAmount: number;
  lastPayment?: Payment;
  status: 'pas à jour' | 'échoué' | 'payé' |  "à jour";
  visited: boolean;
}

export const statusColors = {
  "pas à jour": "gray",
  "pending": "gray",
  "failed": "red",
  "inactive": "red",
  "inactif": "red",
  "paid": "green",
  "à jour": "green",
};

export interface Collector {
  id: string;
  name: string;
  zone: string;
  collectionsToday: number;
  totalCollected: number;
  successRate: number;
  visitsToday: number;
  lastActive: string;
  assignedTaxpayers: number;
  visitedTaxpayers: number;
}

export interface DailyCollection {
  date: string;
  amount: number;
  cumulative: number;
}

export interface ZonePerformance {
  zone: string;
  collected: number;
  total: number;
  contributors: number;
  visitedContributors: number;
  totalContributors: number;
}
